<template>
  <v-dialog
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    width="500"
    :value="dialogStatus"
  >
    <v-card>
      <v-toolbar class="yellow darken-4">
        <v-btn icon dark @click="dialogStatus = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Select filters</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <FilterMenu :dialog="dialogStatus" v-model="dialogStatus"></FilterMenu>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import FilterMenu from "../../components/FilterMenu";
export default {
  data() {
    return {};
  },
  props: ["dialog"],
  components: {
    FilterMenu
  },
  computed: {
    dialogStatus: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style>
</style>
